import React from 'react';
import './MLProjectCard.css';

const MLProjectCard = ({ title, subtitle, description, codeLink }) => {

    return (
        <div className="ml_project__info">
            <h3 className="ml_project__title">
                {title}
                <br/>
                {subtitle}
            </h3>
            <p className="ml_project__description">{description}</p>
            {codeLink && (
                <a href={codeLink} target="_blank" rel="noopener noreferrer">
                    <div className="ml_project__live-2">Github Link</div>
                </a>
            )}
        </div>
    );
};

export default MLProjectCard;